import styled from 'styled-components';

export const GuideView = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
`;
